import React, { useState } from 'react';
import './HomeworkRetrieval.css';
import { s3 } from '../../awsConfig';

const HomeworkRetrieval = () => {
  const [selectedStudent, setSelectedStudent] = useState('');
  const [selectedHomework, setSelectedHomework] = useState('');
  const [files, setFiles] = useState([]);
  const [message, setMessage] = useState('');

  const students = ['Student1', 'Student2', 'Student3'];
  const homeworks = ['Homework1', 'Homework2', 'Homework3', 'Homework4'];

  const handleStudentChange = (e) => {
    setSelectedStudent(e.target.value);
    setSelectedHomework('');
    setFiles([]);
    setMessage('');
  };

  const handleHomeworkChange = (e) => {
    setSelectedHomework(e.target.value);
    setFiles([]);
    setMessage('');
  };

  const handleRetrieve = async () => {
    if (!selectedStudent || !selectedHomework) {
      setMessage('Please select a student and homework');
      return;
    }

    const prefix = `${selectedStudent}/${selectedHomework}/`;
    const params = {
      Bucket: process.env.REACT_APP_S3_BUCKET_NAME,
      Prefix: prefix,
    };

    try {
      const data = await s3.listObjectsV2(params).promise();
      if (data.Contents.length === 0) {
        setFiles([]);
        setMessage('No homework submitted');
      } else {
        const retrievedFiles = data.Contents.map((file) => ({
          key: file.Key,
          url: s3.getSignedUrl('getObject', {
            Bucket: process.env.REACT_APP_S3_BUCKET_NAME,
            Key: file.Key,
            Expires: 60 * 5, // URL expires in 5 minutes
          }),
        }));
        setFiles(retrievedFiles);
        setMessage('');
      }
    } catch (err) {
      setMessage(`Error retrieving files: ${err.message}`);
    }
  };

  return (
    <div className="homework-retrieval">
      <h2>Retrieve Homework</h2>
      <form onSubmit={(e) => e.preventDefault()}>
        <div>
          <label>Select Student:</label>
          <select value={selectedStudent} onChange={handleStudentChange}>
            <option value="">--Select Student--</option>
            {students.map((student) => (
              <option key={student} value={student}>
                {student}
              </option>
            ))}
          </select>
        </div>

        {selectedStudent && (
          <div>
            <label>Select Homework:</label>
            <select value={selectedHomework} onChange={handleHomeworkChange}>
              <option value="">--Select Homework--</option>
              {homeworks.map((homework) => (
                <option key={homework} value={homework}>
                  {homework}
                </option>
              ))}
            </select>
          </div>
        )}

        {selectedHomework && (
          <button type="button" onClick={handleRetrieve}>Retrieve</button>
        )}
      </form>

      {message && <p className="message">{message}</p>}

      <ul>
        {files.map((file, index) => (
          <li key={index}>
            <a href={file.url} target="_blank" rel="noopener noreferrer">{file.key}</a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default HomeworkRetrieval;
